import ChartContainer from '../../../Common/Services/charts/apex-charts/ChartContainer';
import useMonthlyEvolutionRegistersPercentage from './hooks/useMonthlyEvolutionRegistersPercentage';

export const MonthlyEvolutionRegistersPercentage = () => {
    const { chartConfig } = useMonthlyEvolutionRegistersPercentage();

    return (
        <ChartContainer
            title={'Evolução do cadastramento no ano'}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height={450}
        />
    );
};
